<div class="item">
  <mat-slide-toggle
    [disabled]="disabled"
    [(ngModel)]="data.joinMeetingTentativelyAccepted"
    (change)="update.emit()"
    name="join-meeting-tentatively-accepted"
    labelPosition="after"
  >
    {{ 'SETTINGS.JOIN_CALL_TENTATIVELY_ACCEPTED' | translate }}
  </mat-slide-toggle>
</div>
<div class="item">
  <mat-slide-toggle [disabled]="disabled" [(ngModel)]="data.joinMeetingDeclined" (change)="update.emit()" name="join-meeting-declined" labelPosition="after">
    {{ 'SETTINGS.JOIN_CALL_DECLINED' | translate }}
  </mat-slide-toggle>
</div>
<div class="item">
  <mat-slide-toggle
    [disabled]="disabled"
    [(ngModel)]="data.joinMeetingUnresponded"
    (change)="update.emit()"
    name="join-meeting-unresponded"
    labelPosition="after"
  >
    {{ 'SETTINGS.JOIN_CALL_UNRESPONDED' | translate }}
  </mat-slide-toggle>
</div>
<div class="item">
  <mat-slide-toggle
    [disabled]="disabled || joinSettingsFrozen"
    [(ngModel)]="data.joinMeetingInternal"
    (change)="update.emit()"
    name="join-meeting-internal"
    labelPosition="after"
  >
    {{ 'SETTINGS.JOIN_CALL_INTERNAL' | translate }}
  </mat-slide-toggle>
</div>
<div class="item">
  <mat-slide-toggle
    [disabled]="disabled || joinSettingsFrozen"
    [(ngModel)]="data.joinMeetingExternal"
    (change)="update.emit()"
    name="join-meeting-external"
    labelPosition="after"
  >
    {{ 'SETTINGS.JOIN_CALL_EXTERNAL' | translate }}
  </mat-slide-toggle>
</div>
